import Quill from 'quill';

import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';

import { NgForm }                     from '@angular/forms';
import { CustomOption, QuillModules } from 'ngx-quill';

import { TextControlComponent } from '../text-control/text-control.component';

@Component({
  selector   : 'wor-text-editor',
  styles: [ require('./text-editor.component.scss') ],
  template: require('./text-editor.component.html')
})
export class TextEditorComponent extends TextControlComponent implements OnInit {
  @Input () form       ?: ng.IFormController | NgForm;
  @Input () hideToolbar: boolean;

  @Output () readonly modelChange: EventEmitter<string>  = new EventEmitter();

  modules: QuillModules;
  options: Array<CustomOption>;

  ngOnInit () {
    this.modules = {
      toolbar: this.hideToolbar
        ? false
        : [
          [ { 'header': [ 1, 2, 3, 4, 5, 6, false ] } ],
          [ 'bold', 'italic', 'underline', 'strike' ],
          [ { 'color': [] }, { 'background': [] } ],
          [ { 'list': 'ordered' }, { 'list': 'bullet'}, { 'indent': '-1' }, { 'indent': '+1' } ],
          [ { 'align': '' }, { 'align': 'center' }, { 'align': 'right' }, { 'align': 'justify' } ]
        ]
    };

    const Bold   = Quill.import('formats/bold');
    const Italic = Quill.import('formats/italic');

    Bold.tagName   = 'B';
    Italic.tagName = 'I';

    Quill.register(Bold, true);
    Quill.register(Italic, true);

    this.options = [
      {
        import   : 'attributors/style/align',
        whitelist: [ 'center', 'right', 'justify' ]
      }
    ];
  }

  handleModelChange ( _model : string ) : void {
    if (this.form) {
      if (this.form instanceof NgForm) {
        this.form.form.markAsDirty();
      }
      else {
        this.form.$setDirty();
      }
    }

    this.modelChange.emit(_model);
  }
}
